<template>
  <v-card>
    <v-card-title class="align-start">
      <div>
        <p class="mb-2">
          Total Agentes por Fila
        </p>
      </div>
      <v-spacer></v-spacer>
      <v-btn
        icon
        small
        class="mt-n2 me-n3"
      >
        <v-icon size="22">
          {{ icons.mdiDotsVertical }}
        </v-icon>
      </v-btn>
    </v-card-title>
    <v-card-text>
      <!-- Chart -->
      <vue-apex-charts
        height="300"
        type="bar"
        :options="chartOptions"
        :series="chartData"
      ></vue-apex-charts>
    </v-card-text>
  </v-card>
</template>

<script>
// eslint-disable-next-line object-curly-newline
import { mdiDotsVertical, mdiTrendingUp, mdiCurrencyUsd } from '@mdi/js'
import { ref, watch } from '@vue/composition-api'
import VueApexCharts from 'vue-apexcharts'

export default {
  components: {
    VueApexCharts,
  },
  props: {
    dadosTickets: {
      type: Array,
      required: true,
      default: () => [],
    },
  },
  setup(props) {
    const chartOptions = ref({})

    const chartData = ref([])

    function getYandX() {
      const dataNome = props.dadosTickets.map(el => el.filaNome)
      const dataAgentes = props.dadosTickets.map(el => el.totalAgentes)

      chartOptions.value = {

        chart: {
          toolbar: {
            show: true,
          },
        },

        plotOptions: {
          bar: {
            columnWidth: '60%',
            distributed: true,
            borderRadius: 4,
            startingShape: 'rounded',
          },
        },

        dataLabels: {
          enabled: true,
        },
        legend: {
          show: false,
        },
        xaxis: {
          categories: dataNome,

          axisBorder: {
            show: false,
          },
          axisTicks: {
            show: false,
          },

          labels: {
            style: {
              fontSize: '12px',
            },
          },
        },

        yaxis: {
          show: true,
        },

        grid: {
          show: true,
          padding: {
            top: -20,
            left: 0,
            right: -10,
          },
        },
      }

      chartData.value = [{
        name: 'número de agentes',
        data: dataAgentes,
      }]
    }

    watch(() => props.dadosTickets, getYandX, { immediate: true, deep: true })

    return {
      chartOptions,
      chartData,

      icons: {
        mdiDotsVertical,
        mdiTrendingUp,
        mdiCurrencyUsd,
      },
    }
  },
}
</script>

<style lang="scss">
.apexcharts-menu{
  background-color: rgba(145, 85, 253, 0.04) !important;
  border: 0px;
  &:hover {
    background-color: rgba(222, 222, 222, 0.361);
  }
}
</style>
